// Les routes legacy `/widgetsByPageId`, `/widgets`, `/duplicateWidgetToAnotherPage` ne sont plus
// appelées (lot 3 dashboards v2 : GraphQL `dashboard`, `saveDashboard` ; la copie vers une autre page
// est retirée de l'éditeur, 2026-10-28).
// Reste le slice persisté `widgets` (reducer.js), que plus rien ne remplit ni ne lit.
export const GET_WIDGETS_BY_PAGE_ID_SUCCESS = 'GET_WIDGETS_BY_PAGE_ID_SUCCESS'
